module.exports = __webpack_public_path__ + "static/media/img-1.221d8b8f.png";